import { useRouter } from "@/app/hooks/useRouter";
import CartHeaderComponent from "./CartHeaderComponent";
import CartInvoiceTableComponent from "./CartInvoiceTableComponent";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { useEffect } from "react";
import { usePaymentUserWalletAPI } from "@/app/hooks/api_hooks/payment/usePaymentUserWalletAPI";

const CartBillingComponent = () => {
  const { getRouteKey } = useRouter();
  const { customerId } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id")).routeState.state as ICustomerProfileState;
  const { execute: fetchUserWalletDetails } = usePaymentUserWalletAPI();

  //CALL API
  useEffect(() => {
    if (customerId) {
      fetchUserWalletDetails(customerId);
    }
  }, [customerId]);

  return (
    <div className="px-0 py-2 h-full ">
      <div className="bg-white px-2 pb-1 mb-3">
        <p className="text-sm font-semibold pt-2">Payments Page</p>
        <CartHeaderComponent />
      </div>
      <CartInvoiceTableComponent />
    </div>
  );
};

export default CartBillingComponent;

